var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.701,
    height: 21.697,
    viewBox: "0 0 21.701 21.697",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "translate(-18.482 -16.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(18.483 16.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_41",
    "data-name": "Union 41",
    d: "M11389.321,6565.452a4.521,4.521,0,0,1,0-6.391l5.115-5.115a4.521,4.521,0,0,1,6.4,0,.9.9,0,0,1-1.281,1.275,2.713,2.713,0,0,0-3.834,0l-5.115,5.115a2.711,2.711,0,0,0,3.834,3.834l2.557-2.558a.914.914,0,0,1,1.281,0,.9.9,0,0,1,0,1.281l-2.557,2.558a4.529,4.529,0,0,1-6.4,0Zm7.037-7.031a.9.9,0,0,1,1.275-1.282,2.711,2.711,0,0,0,3.834,0l5.629-5.624a2.712,2.712,0,1,0-3.838-3.834l-3.066,3.067a.9.9,0,0,1-1.277-1.282l3.068-3.066a4.519,4.519,0,0,1,6.391,6.391l-5.625,5.631a4.524,4.524,0,0,1-6.391,0Z",
    transform: "translate(-11387.999 -6545.075)",
    fill: "#0e2d49"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOn);
export default __webpack_public_path__ + "static/media/link-on.f1bd982ab1467b84369b6e0b97b95755.svg";
export { ForwardRef as ReactComponent };